<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer/>
			<v-spacer/>
			<v-text-field
				v-model="freeSearch"
				append-icon="mdi-magnify"
				:label="$t('pages.orderFilter.search')"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="cities"
			:loading="loading"
			:search.sync="freeSearch"
			class="elevation-1"
		>
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template #item="{item}">
				<city-row :key="item.id" @edit="onEdit" :city="item"/>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>

	import {types} from "src/store/modules/City.module";
	import FilterAble from "src/mixins/FilterAble";
	import CityRow from "src/view/cities/CityRow";

	export default {
		name: "cities-table",
		props: [],
		components: {
			CityRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {
				loading: false,
				headers: [
					{text: "שם העיר", value: "name"},
					// {text: "מספר פרוייקטים", value: "projects_count"},
					{text: "פעולות", value: "actions"},

				],
				freeSearch: null,
				showDialog: false
			};
		},
		computed: {
			cities() {
				return this.$store.state.CityModule.cities;
			}
		},
		methods: {
			onEdit(City) {
				this.$emit("edit", City);
			}
		}
	};
</script>

<style>

</style>
